import { useState } from "react";
import Loader from "../../common/loader";
import NavBar from "../../common/navbar";
import { baseUrl, handleAuth, postRequestOptions } from "../../common/cookie";
import axios from "axios";

function UpdatePrices() {
  let [error, setError] = useState<any>({});
  let [errorText, setErrorText] = useState<any>("");
  let [unmatchedPositions, setUnmatchedPositions] = useState<any[]>([]);
  let [hidingIndex, setHidingIndex] = useState<number | null>(null);
  let [hideStatus, setHideStatus] = useState<{ [key: number]: string }>({});

  async function handleSubmit(event: any) {
    event.preventDefault();
    setRequestStatus(true);

    try {
      setError({});
      setErrorText("");
      setUnmatchedPositions([]);
      setHideStatus({});
      let form: any = document.getElementById("update-prices");
      let formData = new FormData(form);
      let url = baseUrl + "update-prices";
      let action: any = await axios.post(url, formData, postRequestOptions);

      handleAuth(action.status);
      if (action.data.unmatchedPositions && action.data.unmatchedPositions.length > 0) {
        setUnmatchedPositions(action.data.unmatchedPositions);
      }
      if (action.data.error) {
        if (typeof action.data.error == "string") {
          setErrorText(action.data.error);
        } else {
          setError(action.data.error);
        }
        setRequestStatus(false);
      } else {
        setRequestStatus(false);
        if (!action.data.unmatchedPositions || action.data.unmatchedPositions.length == 0) {
          window.alert("Success!");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      setRequestStatus(false);
    }
  }

  async function handleHidePosition(index: number) {
    let position = unmatchedPositions[index];
    if (!position) return;

    let confirmed = window.confirm(
      `Hide position: ${position["BB Ticker"]} at ${position["Location"]}?\n\nNotional: ${position["Notional Amount"]}\nISIN: ${position["ISIN"]}\n\nThis position was not found in the pricing sheet. It will be removed from the active portfolio and logged as hidden.`
    );
    if (!confirmed) return;

    setHidingIndex(index);
    try {
      let payload = {
        "BB Ticker": position["BB Ticker"],
        "ISIN": position["ISIN"],
        "Location": position["Location"],
        "reason": "Missing from pricing sheet - position likely realized but VCON not yet processed"
      };
      let action: any = await axios.post(baseUrl + "hide-position", payload, postRequestOptions);
      handleAuth(action.status);
      if (action.data && action.data.error) {
        setHideStatus({ ...hideStatus, [index]: "Error: " + action.data.error });
      } else {
        setHideStatus({ ...hideStatus, [index]: "hidden" });
      }
    } catch (error) {
      setHideStatus({ ...hideStatus, [index]: "Error: request failed" });
    }
    setHidingIndex(null);
  }

  let [request, setRequestStatus] = useState(false);

  if (request) {
    return (
      <div>
        <NavBar />
        <Loader />
      </div>
    );
  }
  return (
    <div>
      <NavBar />
      <div className="title">
        <h1>Update Prices</h1>
      </div>
      <div className="card-body card row xlsx-card">
        <form onSubmit={(event) => handleSubmit(event)} encType="multipart/form-data" id="update-prices">
          <div>
            <h3>Input Bloomberg Pricing Excel csv/xlsx file</h3>
          </div>

          <div className="drop-container">
            <input multiple={true} className="drop-box-input" placeholder="Upload or drop file" type="file" name="pricing" accept=".xlsx, .csv" required />
          </div>
          <button type="submit" className="btn upload-btn">
            Upload
          </button>
        </form>
      </div>

      {unmatchedPositions.length > 0 && (
        <div className="card-body card row" style={{ marginTop: "20px", padding: "20px" }}>
          <h3 style={{ marginBottom: "10px" }}>Positions Not Found in Pricing Sheet ({unmatchedPositions.length})</h3>
          <p style={{ marginBottom: "15px", color: "#666", fontSize: "13px" }}>
            These portfolio positions did not match any row in the uploaded pricing sheet.
            Review each one -- if the position has been realized, hide it for later VCON processing.
            If it is a matching issue, leave it as is.
          </p>
          <table className="table-portfolio">
            <thead>
              <tr>
                <th>BB Ticker</th>
                <th>ISIN</th>
                <th>Location</th>
                <th>Notional</th>
                <th>Type</th>
                <th>Currency</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {unmatchedPositions.map((pos: any, index: number) => {
                let status = hideStatus[index];
                return (
                  <tr key={index} style={status == "hidden" ? { opacity: 0.4 } : {}}>
                    <td>{pos["BB Ticker"]}</td>
                    <td>{pos["ISIN"]}</td>
                    <td>{pos["Location"]}</td>
                    <td>{parseFloat(pos["Notional Amount"]).toLocaleString()}</td>
                    <td>{pos["Type"]}</td>
                    <td>{pos["Currency"]}</td>
                    <td>
                      {status == "hidden" ? (
                        <span style={{ color: "#888" }}>Hidden</span>
                      ) : status && status.startsWith("Error") ? (
                        <span style={{ color: "red", fontSize: "12px" }}>{status}</span>
                      ) : (
                        <button
                          className="btn upload-btn"
                          style={{ padding: "4px 12px", fontSize: "12px", margin: 0 }}
                          disabled={hidingIndex === index}
                          onClick={() => handleHidePosition(index)}
                        >
                          {hidingIndex === index ? "Hiding..." : "Hide"}
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <h4 className="error-text">
        {errorText
          ? errorText
          : Object.keys(error).map((issue: any, index: any) => {
              return issue.toString().includes("Bid") || issue.toString().includes("Ask") ? (
                <p key={index}>{error[issue].message}</p>
              ) : (
                <p key={index}>
                  {issue} with location {error[issue].location} did not update. Notional = {error[issue].notional}{" "}
                </p>
              );
            })}
      </h4>
    </div>
  );
}

export default UpdatePrices;
